<template>
  <div>
    <SwappingSquaresSpinner v-if="this.$store.getters.isLoading"
      :animation-duration="1000"
      :size="90"
      :color="this.$store.getters.config.palette.primary"
      style="margin: 30px auto;"
    />
    <div v-if="resetSuccessStatus">
      {{ $t('recover.emailSent') }}
    </div>
    <form v-if="!this.$store.getters.isLoading && !resetSuccessStatus" @submit.prevent="onsubmit" class="login">
      <div class="row mb-2">
        <va-input
          v-model="email"
          type="email"
          :label="$t('auth.email')"
          :error="!!emailErrors.length"
          :error-messages="emailErrors"
        />
      </div>
      <div class="row justify--center">
        <va-button type="submit" class="my-0" style="background-image: unset; background-color: rgb(108, 127, 238); box-shadow: rgb(10 13 117 / 25%) 0 1px 1px 0;">{{ $t('auth.resetPassword') }}</va-button>
      </div>
    </form>
  </div>
</template>

<script>
import { SwappingSquaresSpinner } from 'epic-spinners'
import errorHandlerMixin from '@/mixin/errorHandlerMixin'
export default {
  components: { SwappingSquaresSpinner },
  mixins: [errorHandlerMixin],
  name: 'recover-password',
  data () {
    return {
      email: '',
      emailErrors: [],
      resetSuccessStatus: false,
    }
  },
  methods: {
    async resetSuccess () {
      this.resetSuccessStatus = true
      this.$store.commit('setLoading', false)
    },
    onsubmit () {
      if (!this.email) {
        this.emailErrors = [this.$t('recover.requiredEmail')]
      } else {
        this.resetSuccessStatus = false
        this.$store.commit('setLoading', true)
        this.$store.dispatch('resetPassMail', {
          email: this.email,
        }).then(() => this.resetSuccess()).catch((err) => this.errorHandler(err.response))
      }
    },
  },
}
</script>

<style lang="scss">
</style>
